import { env } from '../../lib/env/env';

export const emberAppConfig = {
  EMBER_APP_BASE_URL: env.getString('EMBER_APP_BASE_URL') || 'http://localhost:4343',
};
